export default __webpack_public_path__ + "static/media/vector-filter.d0fb0772.svg";